module.exports = __webpack_public_path__ + "static/aquarell-ad50337591bf21665c68eea0cc9c52de.png";